import React, { useState } from 'react';
import PolicyModal from '../Policy/PolicyModal';
import './CommonFooter.css';

const CommonFooter = () => {
  const [openPolicyType, setOpenPolicyType] = useState(null);

  return (
    <>
      <footer className="common-footer">
        <div className="footer-content">
          <div className="footer-info">
            <div className="company-info">
              <h4>(주)지케이</h4>
              <p>태양광 발전소 원격 모니터링 서비스</p>
            </div>
            <div className="contact-info">
              <p>사업자등록번호: 578-81-02719</p>
              <p>주소: 전라남도 나주시 왕곡면 혁신산단5길 121</p>
              <p>TEL: 070-4492-8928</p>
            </div>
          </div>

          <div className="footer-links">
            <button
              type="button"
              className="footer-link"
              onClick={() => setOpenPolicyType('TERMS_OF_SERVICE')}
            >
              서비스 이용약관
            </button>
            <span className="footer-link-divider" aria-hidden="true">|</span>
            <button
              type="button"
              className="footer-link"
              onClick={() => setOpenPolicyType('PRIVACY_POLICY')}
            >
              개인정보 처리방침
            </button>
          </div>

          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} (주)지케이. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {openPolicyType && (
        <PolicyModal
          policyType={openPolicyType}
          onClose={() => setOpenPolicyType(null)}
        />
      )}
    </>
  );
};

export default CommonFooter;
